import React from "react";
import {Button, Form, Input, Select, Space} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {useFullVoc} from "../../hooks/voc.hook";
import {moType, stepOption} from "../../stores/fixed/BuildInVocs";
import {makeSelectOption, PatientQuerySimpleEditor} from "./Parts/PatientQuerySimpleEditor";
import {RgSelect} from "../../utils/antdhelper/RgControls";


const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

const TargetAreaEditor =   () =>      <Form.List name={"area"}>
    {(fields, { add, remove }) => (
        <>
            {fields.map(field => (
                <Space key={field.key} align="baseline">
                    <Form.Item
                        {...field}
                        label="Мед.огр"
                        name={[field.name, 'medorg']}
                        fieldKey={[field.fieldKey, 'medorg']}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Select>
                            {moType.map(makeSelectOption)}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        {...field}
                        label="Населённый пункт"
                        name={[field.name, 'subarea']}
                        fieldKey={[field.fieldKey, 'subarea']}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        {...field}
                        label="Район"
                        name={[field.name, 'area']}
                        fieldKey={[field.fieldKey, 'area']}
                    >
                        <Input />
                    </Form.Item>

                    <MinusCircleOutlined onClick={() => remove(field.name)} />
                </Space>
            ))}
            <Form.Item>
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Добавить целевую терроторию
                </Button>
            </Form.Item>
        </>
    )}
</Form.List>


const RoutingForm = ({}) => {
    const event = useFullVoc('eventtp').map(makeSelectOption)
    const [form] = Form.useForm();

    const onFinish = (values) => {
        console.log(values);
    }

    return (<div>
    <Form
        onFinish={onFinish}
    >
        <Form.Item label="Группа пациентов">
            <span className="ant-form-text">Признаки</span>
        </Form.Item>
        <PatientQuerySimpleEditor name={"cond1"}/>
        <Form.Item label={"Этап"} name={"step"}>
            <Select>
                {stepOption.map(makeSelectOption)}
            </Select>
        </Form.Item>
        <Form.Item label="Территория">
            <span className="ant-form-text"></span>
        </Form.Item>
        <TargetAreaEditor></TargetAreaEditor>
        <Space>

            <Form.Item label={"Услуга"} name={"serv"}>
                <Input />
            </Form.Item>
            <RgSelect oid={'eventtp'} label={'Событие'} name={'event'} width={450}></RgSelect>
            <Form.Item label={"Срок, дней"} name={"time"}>
                <Input></Input>
            </Form.Item>


        </Space>
        <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
                Submit
            </Button>
            <Button htmlType="button" >
                Reset
            </Button>
            <Button type="link" htmlType="button" >
                Fill form
            </Button>
        </Form.Item>
    </Form>
</div>)}



export default RoutingForm